module.exports = __webpack_public_path__ + "static/media/route.2370c8a5.svg";